import { Actions } from './indicateursActions';
import { Actions as UtilisateurCourantActions } from '../utilisateur/courantActions';

/**
 * Etat initial pour les indicateurs
 */
const initialState = {
    emises: {
        valeur: -1,
        isLoading: false,
        didInvalidate: false
    },
    affectees: {
        valeur: -1,
        isLoading: false,
        didInvalidate: false
    },
    commentaires: {
        valeur: -1,
        isLoading: false,
        didInvalidate: false
    },
    creees: {
        valeur: -1,
        isLoading: false,
        didInvalidate: false
    },
    cloturees: {
        valeur: -1,
        isLoading: false,
        didInvalidate: false
    },
    observateur: {
        valeur: -1,
        isLoading: false,
        didInvalidate: false
    }
}

/**
 * Reducer pour les indicateurs
 */
const reducer = (state = initialState, action) => {

    switch (action.type) {
        case Actions.FETCH_RECLAMATION_INDICATEUR_REQUEST:
            return {
                ...state,
                [action.key]: {
                    ...state[action.key],
                    isLoading: true,
                    didInvalidate: false
                }
            };
        case Actions.FETCH_RECLAMATION_INDICATEUR_SUCCESS:
            return {
                ...state,
                [action.key]: {
                    valeur: action.valeur,
                    isLoading: false,
                    didInvalidate: false
                }
            };
        case Actions.FETCH_RECLAMATION_INDICATEUR_FAILURE:
            return {
                ...state,
                [action.key]: {
                    ...state[action.key],
                    isLoading: false,
                    didInvalidate: true,
                    error: action.error
                }
            };
        case Actions.INVALIDATE_RECLAMATION_INDICATEUR:
            return {
                ...state,
                [action.key]: { ...state[action.key], didInvalidate: true }
            };

        case UtilisateurCourantActions.LOGOUT:
            return { ...initialState };

        default:
            return state;
    }
}

export default reducer;